@if (headline && text) {
  <div class="info variant-2 mt-4 mt-lg-0 mb-5" data-zid="custom-info-card">
    <h3 class="mb-4">{{ headline }}</h3>
    <p>{{ text }}</p>
  </div>
}
